import React from 'react';

import styles from './ReviewItem.module.css';

type TProps = {
  text: string;
};

export const ReviewItemDate = ({ text }: TProps) => (
  <div className={styles.ReviewItem__Date}>{text}</div>
);
